/**
 * languageSync.js — Sync the chosen UI language with the backend user profile.
 *
 * ★ 2026-08-26 (Fase 55) — Persistenza lingua utente cross-device.
 *
 *  • Se l'utente NON è loggato → nessuna chiamata (solo localStorage tramite i18n).
 *  • Se l'utente È loggato → PATCH /api/auth/me/language con la nuova lingua.
 *    Errori vengono silenziati (best-effort): la UI ha già aggiornato la lingua.
 *
 *  Il valore torna anche nel payload di /auth/me quindi al prossimo login/refresh
 *  potremo eventualmente forzare la lingua profilo (opzionale).
 */
import { api } from './api';
import { getToken } from './tokenStorage';
import { logger } from './logger';

const SUPPORTED = new Set(['it', 'en', 'es', 'no', 'ru']);

/**
 * Persist the current UI language to the backend profile if the visitor is
 * authenticated. Fire-and-forget: never throws.
 * @param {string} code   ISO code (it | en | es | no | ru).
 */
export async function syncLanguageToProfile(code) {
  if (!code || !SUPPORTED.has(code)) return;
  try {
    if (!getToken()) return; // public visitor → nothing to persist server-side
    await api.patch('/auth/me/language', { preferred_language: code });
  } catch (err) {
    logger.debug('syncLanguageToProfile failed (non-fatal)', err);
  }
}

export default syncLanguageToProfile;
